import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const RobotsTxtRoutes: RouteRecordRaw = {
  path: '/robots-txt',
  name: 'RobotsTxtModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageRobotsTxtRoute',
      component: () => import('./views/ManageRobotsTxtView.vue'),
      meta: {
        title: 'robots.txt',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.robotsTxt,
  },
}

export default (router: Router) => {
  router.addRoute(RobotsTxtRoutes)
}
